import styled from "styled-components";
export const Styles = styled.div`
  .btn-chat {
    display: flex;
    justify-content: end;
    margin-top: 56px;
    position: fixed;
    right: 40px;
    bottom: 40px;
    z-index: 10000;
    button {
      border: 1px solid #1e3666;
      background: #1e3666;
      display: flex;
      column-gap: 4px;
      align-items: center;
      height: 38px;
      border-radius: 100px;
      cursor: grab;
      p {
        width: 16px;
        height: 16px;
        background: #1e90ff;
        font-size: 10px;
        text-align: center;
        border-radius: 50%;
        line-height: 16px;
      }
    }
  }
`;
